const DEFAULT_STATE = {
  conceptSearch: null,
  spottingArea: null,
  actor: null,
  mediaType: null,
  facetKeyword: null,
  knowledgeBaseFilters: null,
  bookmarks: {
    posts: {},
    loading: false,
  },
}

const state = { ...DEFAULT_STATE }

export const MUTATION_TYPES = {
  SET_CONCEPT_SEARCH: 'KNOWLEDGE_BASE/SET_CONCEPT_SEARCH',
  SET_SPOTTING_AREA: 'KNOWLEDGE_BASE/SET_SPOTTING_AREA',
  SET_ACTOR: 'KNOWLEDGE_BASE/SET_ACTOR',
  SET_MEDIA_TYPE: 'KNOWLEDGE_BASE/SET_MEDIA_TYPE',
  SET_FACET_KEYWORD: 'KNOWLEDGE_BASE/SET_FACET_KEYWORD',
  CLEAR: 'KNOWLEDGE_BASE/CLEAR',
  SET_KNOWLEDGE_BASE_FILTERS: 'KNOWLEDGE_BASE/SET_KNOWLEDGE_BASE_FILTERS',
  SET_POST_BOOKMARK_STATUS: 'KNOWLEDGE_BASE/SET_POST_BOOKMARK_STATUS',
  SET_BOOKMARKS_LOADING: 'KNOWLEDGE_BASE/SET_BOOKMARKS_LOADING',
  UPDATE_POST_BOOKMARKS_COUNT: 'KNOWLEDGE_BASE/UPDATE_POST_BOOKMARKS_COUNT',
}

export const mutations = {
  [MUTATION_TYPES.CLEAR] (state) {
    state = DEFAULT_STATE

    // ls('knowledgeBaseKeywords', {}) // We don't store the state in the ls anymore
  },
  [MUTATION_TYPES.SET_CONCEPT_SEARCH] (state, conceptSearch) {
    state.conceptSearch = conceptSearch
  },
  [MUTATION_TYPES.SET_SPOTTING_AREA] (state, spottingArea) {
    state.spottingArea = spottingArea
  },
  [MUTATION_TYPES.SET_MEDIA_TYPE] (state, mediaType) {
    state.mediaType = mediaType
  },
  [MUTATION_TYPES.SET_FACET_KEYWORD] (state, keyword) {
    state.facetKeyword = keyword
  },
  [MUTATION_TYPES.SET_ACTOR] (state, actor) {
    state.actor = actor
  },
  [MUTATION_TYPES.SET_KNOWLEDGE_BASE_FILTERS] (state, filters) {
    state.knowledgeBaseFilters = filters
  },
  [MUTATION_TYPES.SET_POST_BOOKMARK_STATUS] (state, { postId, isBookmarked, bookmarksCount }) {
    state.bookmarks.posts[postId] = {
      isBookmarked,
      bookmarksCount,
    }
  },
  [MUTATION_TYPES.SET_BOOKMARKS_LOADING] (state, loading) {
    state.bookmarks.loading = loading
  },
  [MUTATION_TYPES.UPDATE_POST_BOOKMARKS_COUNT] (state, { postId, bookmarksCount }) {
    if (state.bookmarks.posts[postId]) {
      state.bookmarks.posts[postId].bookmarksCount = bookmarksCount
    }
  }
}

const getters = {
  getPostBookmarkStatus: (state) => (postId) => {
    return state.bookmarks.posts[postId] || { isBookmarked: false, bookmarksCount: 0 }
  },
  isPostBookmarked: (state) => (postId) => {
    return state.bookmarks.posts[postId]?.isBookmarked || false
  },
  getPostBookmarksCount: (state) => (postId) => {
    return state.bookmarks.posts[postId]?.bookmarksCount || 0
  },
  isBookmarksLoading: (state) => {
    return state.bookmarks.loading
  }
}

const actions = {
  async toggleBookmark({ commit }, { postId, communityId = null }) {
    try {
      commit(MUTATION_TYPES.SET_BOOKMARKS_LOADING, true)
      
      const { toggleBookmark } = await import('@/api/knowledge-base')
      const response = await toggleBookmark(postId, communityId)
      
      if (response.success) {
        commit(MUTATION_TYPES.SET_POST_BOOKMARK_STATUS, {
          postId,
          isBookmarked: response.is_bookmarked,
          bookmarksCount: response.bookmarks_count,
        })
      }
      
      return response
    } catch (error) {
      console.error('Error toggling bookmark:', error)
      throw error
    } finally {
      commit(MUTATION_TYPES.SET_BOOKMARKS_LOADING, false)
    }
  },
  
  async checkBookmark({ commit }, { postId, communityId = null }) {
    try {
      const { checkBookmark } = await import('@/api/knowledge-base')
      const response = await checkBookmark(postId, communityId)
      
      if (response.success) {
        commit(MUTATION_TYPES.SET_POST_BOOKMARK_STATUS, {
          postId,
          isBookmarked: response.is_bookmarked,
          bookmarksCount: response.bookmarks_count,
        })
      }
      
      return response
    } catch (error) {
      console.error('Error checking bookmark:', error)
      throw error
    }
  },
  
  updatePostBookmarkStatus({ commit }, { postId, isBookmarked, bookmarksCount }) {
    commit(MUTATION_TYPES.SET_POST_BOOKMARK_STATUS, {
      postId,
      isBookmarked,
      bookmarksCount,
    })
  }
}

export default {
  state,
  mutations,
  getters,
  actions,
}
